<template>
<v-container grid-list-sm fluid text-xs-center mt-5 pt-5>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <v-layout row wrap justify-content-center pb-3 v-if="isDesktop()" style="margin-bottom:10%">
        <!-- <pre>
            {{Devis_pour_souscription}}
        </pre> -->
        <v-flex xs11 pb-3 pt-4 justify-content-center row>
            <v-toolbar dark flat color="rgba(255,164,9,0.8)" class="justify-content-center row">
                <v-toolbar-title class="justify-center">
                    <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%" />
                    <span style="font-size: 25px" class="policeLato">
                        Numéro Devis : {{Devis_pour_souscription.numero_police}}
                    </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <p class="font-weight-bold policeLato" style="color:red">
                Vous serez redirigé vers la page d’accueil dans : {{Mano}} mn
            </p>
        </v-flex>

        <v-flex xs10 sm10 md11 lg11 pb-3 justify-content-center class="row block-content elevation-0 row-container mt-3 grey lighten-3 border-radius policeLato">
            <!--logo Assureur et Notation étoilée-->
            <v-flex xs3 row wrap justify-content-center mt-5>
                <v-flex v-if="Devis_pour_souscription!=null">
                    <img :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)" :title="Devis_pour_souscription.partenaireid.societe" alt="partenaire logo" width="150" height="120" />
                    <p class="font-weight-black pl-2 policeLato">{{Devis_pour_souscription.partenaireid.societe}}</p>
                </v-flex>
            </v-flex>

            <v-flex xs3 row wrap justify-content-center mt-5>
                <!--Tarifs-->
                <v-flex>
                    <ul class="List-cout pl-5">
                        <li  v-if="Devis_pour_souscription!=null">
                            <p class="font-weight-bold text-center policeLato" style="color:#ffa409;font-size:25px;">
                                {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                <small>FCFA</small>
                            </p>
                        </li>
                        <span class="font-weight-black title policeLato">Prime TTC</span>
                        <p><small class="title font-weight-light policeLato">(Frais et taxes inclus)</small></p>
                    </ul>
                </v-flex>
            </v-flex>

            <v-flex xs4 row wrap justify-content-center>
                <!--bouttons ...-->
                <v-flex class="right--texting">
                    <ul class="list-boutons">
                        <li>
                            <v-btn small color="default" @click="assistanceDialogManip(Devis_pour_souscription)" class="col-lg-6 col-sm-6 col-md-6 policeLato">
                                <i class="pr-4 material-icons icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe0cf;</i>Être
                                Rappelé
                            </v-btn>
                        </li>

                        <li>
                            <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)" class="col-lg-6 col-sm-6 col-md-6 policeLato">
                                <i class="pr-4 material-icons icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe2c4;</i>
                                Télécharger
                            </v-btn>
                        </li>

                        <li>
                            <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)" class="col-lg-6 col-sm-6 col-md-6 policeLato">
                                <i class="pr-4 material-icons icon-action-devis" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                            </v-btn>
                        </li>


                        <li>
                            <v-btn small color="default" @click="payement_start" class="col-lg-6 col-sm-6 col-md-6 policeLato">
                                <i class="mr-4 material-icons icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-33%">&#xe8a1;</i>
                                Payer
                            </v-btn>
                        </li>
                    </ul>
                </v-flex>
            </v-flex>
        </v-flex>


        <v-flex xs10 sm10 md11 lg11 pb-3 justify-content-center class="row block-content elevation-0 row-container mt-3 grey lighten-3 border-radius policeLato">
            <div>
                    <ul class="to-left mt-1 mb-3 policeLato justify-center row">

                        <li class="to left font-weight-regular subheading">Durée des cotisations :
                            <span class="ml-1 to-right" style="color: #ffa409"> {{Devis_pour_souscription.details[0].duree}} ans</span>
                        </li>
                        <li class="ml-3 to left font-weight-regular subheading">Capital à terme:
                            <span class="ml-1 to-right" style="color: #ffa409"> {{Devis_pour_souscription.details[0].capital.toLocaleString()}} FCFA</span>
                        </li>
                        <li class="ml-3 to left font-weight-regular subheading">prime mensuelle:
                            <span class="ml-1 to-right" style="color: #ffa409"> {{Devis_pour_souscription.details[0].prime_mensuelle.toLocaleString()}} FCFA</span>
                        </li>
                        <li class="ml-3 to left font-weight-regular subheading">Rente annuelle:
                            <span class="ml-1 to-right" style="color: #ffa409"> {{Devis_pour_souscription.details[0].Rente.toLocaleString()}} FCFA</span>
                        </li>
                        <li class="ml-3 to left font-weight-regular subheading">Date d'effet:
                            <span class="ml-1 to-right" style="color: #ffa409"> {{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                        </li>
                    </ul>
            </div>
        </v-flex>

        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <v-flex justify-content-center row v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
            <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius">
                <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                    <p class="font-weight-black headline policeLato">Détails de l'assurance</p>
                </v-flex>

                <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container bg-transparent">
                    <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                        <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                            <thead class="bg-light policeLato">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Automobile WEB===================================================-->
                                    <td>
                                        <ul class="to-left mb-3 policeLato" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                                            <li class="font-weight-regular subheading">Marque :
                                                <span class="to-right">{{auto.marque}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Modèle :
                                                <span class="to-right">{{auto.model}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Immatriculation :
                                                <span class="to-right">{{auto.immatriculation}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Categorie :
                                                <span>{{auto.categorie}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Option Utilitaire :
                                                <span>{{auto.optionUtilitaire}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Tonnage :
                                                <span>{{auto.tonnage}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading" v-show="auto.categorie=='2_roues'">Volumetrie 2 roues :
                                                <span>{{auto.volumetrie2_roues}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Valeur à neuf :
                                                <span class="to-right">{{auto.valeur}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Valeur vénale :
                                                <span class="to-right">{{auto.valeur_venale}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Force :
                                                <span class="to-right">{{auto.force}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Age du véhicule :
                                                <span class="to-right">{{auto.age}} {{auto.annee_mois}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Nombre de places :
                                                <span class="to-right">{{auto.nbplace}}</span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>

                                    <!--============================================Liste Garanties si c'est devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayement.devis.brancheid.branche=='Automobile'">
                                        <ul class="to-left uppercase policeLato" v-for="(gar, index) in listegaranties" :key="index" style="margin-bottom: 200px">
                                            <ul v-for="(g, index) in gar" :key="index">
                                                <li>{{g}}</li>
                                            </ul>
                                        </ul>
                                    </td>

                                    <!--============================================Autres informations===================================================-->
                                    <td v-if="this.$store.state.devispayement.devis.brancheid.branche=='Automobile'">
                                        <ul class="to-left pb-3 policeLato" v-for="(auto,index) in Devis_pour_souscription.vehicules" :key="index">
                                            <li class="font-weight-regular subheading">Date d'effet :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date d'échéance :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Assureur:
                                                <span class="to-right">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date de souscription :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Bénéficiaire :
                                                <span class="to-right">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
        <!--======================================= End Detail block if Automobile DESKTOP ========================================================-->

        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <!--========= Details Assurance cas Habitation DESKTOP ================-->
        <v-flex justify-content-center row v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
            <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius">
                <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                    <p class="font-weight-black headline policeLato">Détails de l'assurance</p>
                </v-flex>

                <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container bg-transparent">
                    <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                        <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                            <thead class="bg-light policeLato">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Habitation WEB===================================================-->
                                    <td v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
                                        <ul class="to-left policeLato">
                                            <li class="font-weight-regular subheading">Type de Bien :
                                                <span class="to-right">{{Devis_pour_souscription.typeBien}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Type toiture :
                                                <span class="to-right">{{Devis_pour_souscription.naturecouverture}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Superficie (m2) :
                                                <span class="to-right">{{Devis_pour_souscription.nombreetage}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Adresse du logement :
                                                <span class="to-right">{{Devis_pour_souscription.adresselogement}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Valeur du bâtiment :
                                                <span class="to-right">{{Devis_pour_souscription.valeurbatiment}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Valeur du contenu :
                                                <span class="to-right">{{Devis_pour_souscription.valeurcontenu}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Qualité assuré :
                                                <span class="to-right">{{Devis_pour_souscription.qualiteassure}}</span>
                                            </li>

                                            <li v-if="Devis_pour_souscription.qualiteassure=='locataire'">Montant du
                                                loyer :
                                                <span class="to-right">{{Devis_pour_souscription.montaLoyer}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Nombre de pièces :
                                                <span class="to-right">{{Devis_pour_souscription.nombrepiece}}</span>
                                            </li>
                                        </ul>
                                    </td>

                                    <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'">
                                        <ul class="to-left uppercase policeLato" v-for="(gar,index) in listegaranties" :key="index">
                                            <ul>
                                                <li>{{gar.libele}}</li>
                                            </ul>
                                        </ul>
                                    </td>

                                    <!--============================================Autres informations de devis Auto===================================================-->
                                    <td v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
                                        <ul class="to-left pb-3 policeLato">
                                            <li class="font-weight-regular subheading">Date d'effet :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date d'échéance :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Assureur:
                                                <span class="to-right">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date de souscription :
                                                <span class="to-right">{{ DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Bénéficiaire :
                                                <span class="to-right">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-flex>
        <!--======================================= End Detail block if Habitation DESKTOP ========================================================-->

        <!--======== Details Assurance cas Voyage DESKTOP =====================-->
        <!--======== Details Assurance cas Voyage DESKTOP =====================-->
        <!--======== Details Assurance cas Voyage DESKTOP =====================-->
        <!--======== Details Assurance cas Voyage DESKTOP =====================-->
        <v-flex justify-content-center row v-show="showPaymentBLock==true">
            <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius" v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                    <p class="font-weight-black headline policeLato">Détails de l'assurance</p>
                </v-flex>

                <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container bg-transparent">
                    <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                        <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                            <thead class="bg-light policeLato">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Voyage WEB===================================================-->
                                    <td v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                                        <ul class="to-left policeLato">
                                            <li class="font-weight-regular subheading">Pays de départ :
                                                <span class="to-right">{{Devis_pour_souscription.pays_domicile}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Pays de destination :
                                                <span class="to-right">{{Devis_pour_souscription.destination.PAYS}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Nombre de passagers :
                                                <span class="to-right">{{Devis_pour_souscription.nbpassager}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date de départ :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateDepart)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date de retour :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateArrivee)}}</span>
                                            </li>
                                        </ul>
                                    </td>

                                    <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'">
                                        <ul class="to-left uppercase policeLato" v-for="(gar, index) in listegaranties" :key="index">
                                            <ul>
                                                <li>{{gar}}</li>
                                            </ul>
                                        </ul>
                                    </td>

                                    <!--============================================Autres informations===================================================-->
                                    <td>
                                        <ul class="to-left pb-3 policeLato">
                                            <li class="font-weight-regular subheading">Date d'effet :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateDepart)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date d'échéance :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Assureur:
                                                <span class="to-right">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                            </li>

                                            <li class="font-weight-regular subheading">Date de souscription :
                                                <span class="to-right">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-flex>

                <v-flex xs11 sm10 md11 lg11 pb-3 pt-1 justify-content-center class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                    <table class="table table-sm table-bordered grey lighten-5 table-simple text-center">
                        <thead class="bg-light policeLato">
                            <tr>
                                <th class="head">Genre</th>
                                <th class="head">Prénom</th>
                                <th class="head">Nom</th>
                                <th class="head">Numéro de téléphone</th>
                                <th class="head">Nationalité</th>
                                <th class="head">Date de naissance</th>
                                <th class="head">№ Passeport</th>
                                <th class="head">Date de délivrance</th>
                                <th class="head">Date d'expiration</th>
                            </tr>
                        </thead>

                        <tbody v-for="(item,index) in tableau_info_passager" :key="index">
                            <tr>
                                <td class="font-weight-regular subheading border">{{item.genre}}</td>
                                <td class="font-weight-regular subheading border">{{item.prenom_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.nom_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.num_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.nationalite_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.dateNaissance}}</td>
                                <td class="font-weight-regular subheading border">{{item.numero_ci_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.date_delivrance}}</td>
                                <td class="font-weight-regular subheading border">{{item.date_expiration}}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-flex>
            </v-flex>
        </v-flex>
        <!--======================================= End Detail block if Voyage DESKTOP ============================================================-->

        <!--======== Partie paiement pour les devis auto, habitation et voyage DESKTOP =====================-->
        <!--======== Partie paiement pour les devis auto, habitation et voyage DESKTOP =====================-->
        <!--======== Partie paiement pour les devis auto, habitation et voyage DESKTOP =====================-->
        <!--======== Partie paiement pour les devis auto, habitation et voyage DESKTOP =====================-->
        <v-flex justify-content-center row>
            <v-flex xs11 sm10 md11 lg11 pb-3 pt-3 justify-content-center class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                <!-- How to deliver The insurance if subcripted WEB-->
                <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                    <p class="font-weight-black headline policeLato">Checkout</p>
                </v-flex>

                <v-card width="500" class="border-radius">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="policeLato">Mode de livraison</v-toolbar-title>
                    </v-toolbar>

                    <v-item-group style="margin-top:-15px">
                        <ul>
                            <v-radio-group full-width class="answer policeLato" v-model="mode_livraison">
                                <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" value="a_domicile" @change="adresse = true"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire" disabled></v-radio>
                                <v-flex class="ml-0 row">
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                                    <h6 class="pt-2" @click="aStorMap=true">Voir plan ici</h6>
                                </v-flex>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-card width="500" class="ml-5 border-radius">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="policeLato">Mode de paiement</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group style="margin-top:-15px">
                        <ul>
                            <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement" class="answer policeLato">
                                <v-radio color="#ffa409" class="highlight" label="Orange money" value="mobile_money"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Free Money" value="free_money"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement" ></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch" disabled></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire" disabled></v-radio>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-flex xs12 mt-2 justify-content-center column v-show="mode_livraison" v-model="fraisLiv">
                    <span class="h6">Prime TTC: <span class="font-weight-bold" style="color: #ffa409">{{ Devis_pour_souscription.prime_ttc.toLocaleString()}}</span><small> FCFA</small></span>
                    <span class="h6">Frais livraison: <span class="font-weight-bold" style="color: #ffa409">{{ fraisLiv }}</span><small> FCFA</small></span>
                    <span class="h6">Frais paiement: <span class="font-weight-bold" style="color: #ffa409">{{ fraisPaiement }}</span><small> FCFA</small></span>
                </v-flex>

                <v-flex xs12 justify-content-center column v-show="mode_livraison">
                    <span class="font-weight-black h2">TOTAL :<span class="red--text">{{ mention_ttc.toLocaleString() }}</span>
                        <small> FCFA</small>
                    </span>
                </v-flex>

                <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">

                    <!--Bouton de Paiement Avec les wallet dispo sur upay payement_end-->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                        Payer
                    </v-btn>

                    <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'" @click="payment_Orabank" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>

                    <!--Bouton de Paiement Par OrangeMoney Assuraf-->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>

                    <!--Bouton de Paiement par Freemoney -->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'intouch'" @click="payement_intouch_start" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'free_money'" @click="payment_free" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-flex>

        <!-- popup pour remplissage informations passagers devis voyage Desktop-->
        <v-dialog v-model="dialogInfoPassager" persistent v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
            <v-card v-if="isDesktop()" elevation="24" class="border-radius policeLato">
                <v-toolbar card color="#ffa409">
                    <span class="font-weight-black title policeLato" style="color:#fff">
                        <v-icon color="#fff">&#xe92d;</v-icon>Informations passager(s)
                    </span>
                </v-toolbar>

                <v-flex class="border-radius grey lighten-3 column text-center mt-3 ml-3 mr-3">
                    <small style="color:red">
                        * Date de naissance du passager fixée selon le devis
                    </small>
                    <v-flex>
                        <v-form class="text-center row">
                            <v-container class="text-center">
                                <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                    <v-flex md3>
                                        <v-radio-group class="justify-content-center row" v-model="genre" row>
                                            <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                            <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                        </v-radio-group>
                                    </v-flex>

                                    <v-flex md3 class="ml-2">
                                        <v-text-field v-model="prenom_passager" prepend-inner-icon="person" label="Prénom*" required hint="Votre prénom complet"></v-text-field>
                                    </v-flex>

                                    <v-flex md3>
                                        <v-text-field class="ml-2" v-model="nom_passager" prepend-inner-icon="person" label="Nom*" required hint="Votre nom complet"></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout ml-3 mr-3 pt-3 class="row justify-content-center">
                                    <v-flex md3 style="margin-top:-20px">
                                        <v-text-field @keypress="onlyNumber" prepend-inner-icon="phone" v-model="num_passager" label="Téléphone*" required hint="Votre numéro de téléphone"></v-text-field>
                                    </v-flex>

                                    <v-flex class="ml-2" md3 style="margin-top:-25px">
                                        <label for>Nationalité*</label>
                                        <select solo v-model="nationalite_passager" class="border selectatDesktop col-md-11 pt-3">
                                            <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                                {{itm.PAYS}}
                                            </option>
                                        </select>
                                    </v-flex>

                                    <v-flex md3 style="margin-top:-20px">
                                        <v-text-field slot="activator" outline label="Date de naissance*" v-model="dateNaissance" prepend-inner-icon="event" readonly></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                    <v-flex md3 class="row" style="margin-top:-20px">
                                        <v-text-field v-model="numero_ci_passager" prepend-inner-icon="person" placeholder="№ Passeport*" required type="text" hint="Numéro Passeport"></v-text-field>
                                    </v-flex>

                                    <v-flex class="ml-2" md3 style="margin-top:-20px">
                                        <v-menu lazy :close-on-content-click="false" v-model="menuDelivrance" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" label="Date de délivrance*" v-model="date_delivrance" prepend-inner-icon="event"></v-text-field>
                                            <v-date-picker color="#ffa409" v-model="date_delivrance" class="mt-3" @input="menuDelivrance=false" min="1950-01-01" :max="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex md3 style="margin-top:-20px">
                                        <v-menu lazy :close-on-content-click="false" v-model="menuExpiration" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" label="Date expiration*" v-model="date_expiration" prepend-icon="event"></v-text-field>
                                            <v-date-picker color="#ffa409" v-model="date_expiration" class="mt-3" @input="menuExpiration=false" :min="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-flex>
                </v-flex>

                <v-flex class="row">
                    <div class="col-sm-12 text-center">
                        <v-btn class="font-weight-bold policeLato text-white" round color="red" to="/">Annuler</v-btn>
                        <v-btn class="font-weight-bold policeLato text-white" round color="#ffa409" @click="Detail_info_passager">Ajouter
                        </v-btn>
                    </div>
                </v-flex>

                <v-layout wrap>
                    <v-flex xs12 ml-5 mr-5>
                        <table class="table table-simple text-center">
                            <thead class="bg-light">
                                <tr>
                                    <th>Genre</th>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                    <th>Numéro de téléphone</th>
                                    <th>Nationalité</th>
                                    <th>Date de naissance</th>
                                    <th>№ Passeport</th>
                                    <th>Date de délivrance</th>
                                    <th>Date d'expiration</th>
                                </tr>
                            </thead>

                            <tbody v-for="item in tableau_info_passager" :key="item.numero_ci_passager">
                                <tr>
                                    <td class="border">{{item.genre}}</td>
                                    <td class="border">{{item.prenom_passager}}</td>
                                    <td class="border">{{item.nom_passager}}</td>
                                    <td class="border">{{item.num_passager}}</td>
                                    <td class="border">{{item.nationalite_passager}}</td>
                                    <td class="border">{{item.dateNaissance}}</td>
                                    <td class="border">{{item.numero_ci_passager}}</td>
                                    <td class="border">{{item.date_delivrance}}</td>
                                    <td class="border">{{item.date_expiration}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>

                    <v-flex class="justify-content-center row" v-show="continue_btn">
                        <v-btn class="font-weight-bold text-white policeLato" round color="#ffa409" @click="ManipPaiement()">Continuer
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="isDesktop()">
            <v-card>
                <v-toolbar card color="#ffa409">
                    <span class="font-weight-black title" style="color:#fff">
                        <v-icon color="#fff">&#xe55b;</v-icon>
                        <span style="font-weight:bold;font-size:14px!important;">Plan d'accès</span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="aStorMap=false" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-layout xs10 pa-3 justify-content-center row>
                        <v-flex>
                            <iframe class="border-radius" width="100%" height="608" id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1808.921643560724!2d-17.463326864934903!3d14.710734999189677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQyJzM4LjciTiAxN8KwMjcnNDUuOCJX!5e1!3m2!1sfr!2ssn!4v1587561379330!5m2!1sfr!2ssn" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <v-container style="padding-right:25px!important;padding-bottom:25px!important; padding-left:25px!important;margin-bottom:25%" v-if="isMobile()">
        <v-flex pt-2>
            <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                <v-toolbar-title class="align-center">
                    <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%" />
                    <span style="font-size: 15px" class="policeLato">Nº Devis : {{Devis_pour_souscription.numeroDevis}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <p class="red--text font-weight-bold text-center policeLato">Vous serez redirigé vers la page d’accueil
                dans {{Mano}} mn</p>
        </v-flex>

        <!--Details de l'assureurs-->
        <v-layout column justify-content-center class="mt-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
            <!--logo Assureur et Notation étoilée-->
            <v-flex justify-content-center style="text-align: center; margin-top: -2%" class="pt-5">
                <img :src="Devis_pour_souscription.partenaireid.logo" :title="Devis_pour_souscription.partenaireid.societe" width="130" height="100" />
                <p class="font-weight-black policeLato">{{Devis_pour_souscription.partenaireid.societe}}</p>
            </v-flex>

            <!--bouttons ...-->
            <v-flex row wrap xs12 sm10 md11 lg11 pb-3 pt-2>
                <v-flex row wrap justify-content-center class="right--texting pl-3">
                    <ul class="list-boutons">
                        <li>
                            <v-btn small @click="assistanceDialogManip(Devis_pour_souscription)" color="default" class="col-lg-6 col-sm-6 col-md-6 font-weight-bold policeLato">
                                <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0cf;</i>Être Rappelé
                            </v-btn>
                        </li>

                        <li>
                            <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)" class="col-lg-6 col-sm-6 col-md-6 font-weight-bold policeLato">
                                <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0be;</i>Devis par mail
                            </v-btn>
                        </li>

                        <li>
                            <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)" class="col-lg-6 col-sm-6 col-md-6 font-weight-bold policeLato">
                                <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe2c4;</i>Télécharger
                            </v-btn>
                        </li>

                        <li>
                            <v-btn small color="default" @click="payement_start" class="col-lg-6 col-sm-6 col-md-6 font-weight-bold policeLato">
                                <i class="material-icons" aria-hidden="true" data-nosnippet style="margin-left:-32%;padding-right:25px">&#xe8a1;</i>Payer
                            </v-btn>
                        </li>
                    </ul>
                </v-flex>

                <!--Tarifs-->
                <v-flex xs12 class="pt-4">
                    <ul class="List-cout">
                        <li>
                            <p class="font-weight-black title justify-content-center row" style="color:#ffa409">
                                {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                <small class="ml-1">FCFA</small>
                            </p>
                        </li>
                        <span class="font-weight-black title justify-content-center row policeLato">Prime TTC</span>
                        <li>
                            <p class="justify-content-center row policeLato">(Frais et taxes inclus)</p>
                        </li>
                    </ul>
                </v-flex>
            </v-flex>
        </v-layout>

        <!--============== Details Assurance cas Automobile MOBILE =====================-->
        <!--============== Details Assurance cas Automobile MOBILE =====================-->
        <!--============== Details Assurance cas Automobile MOBILE =====================-->
        <!--============== Details Assurance cas Automobile MOBILE =====================-->
        <v-layout column justify-content-center v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
            <v-layout column justify-content-center class="mt-3 pb-3 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                <v-flex>
                    <span class="font-weight-black headline policeLato">Détails de l'assurance</span>
                </v-flex>

                <v-flex class="row mt-2 policeLato" justify-content-center>
                    <!--==============Details Assurance cas Automobile MOBILE=====================-->
                    <v-flex justify-content-center ml-3 row>
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Objet(s) assuré(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey;">
                                <ul class="to-left policeLato" style="margin-left:-7%" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                                    <li class="font-weight-regular subheading">Marque :
                                        <span class="to-right-mobile">{{auto.marque}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Modèle :
                                        <span class="to-right-mobile">{{auto.model}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Immatriculation :
                                        <span class="to-right-mobile">{{auto.immatriculation}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Categorie :
                                        <span>{{auto.categorie}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Option Utilitaire :
                                        <span>{{auto.optionUtilitaire}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">Tonnage :
                                        <span>{{auto.tonnage}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading" v-show="auto.categorie=='2_roues'">
                                        Volumetrie 2 roues :
                                        <span>{{auto.volumetrie2_roues}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Valeur à neuf :
                                        <span class="to-right-mobile">{{auto.valeur}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Valeur vénale :
                                        <span class="to-right-mobile">{{auto.valeur_venale}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Force :
                                        <span class="to-right-mobile">{{auto.force}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Age du véhicule :
                                        <span class="to-right-mobile">{{auto.age}} {{auto.annee_mois}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Nombre de place(s) :
                                        <span class="to-right-mobile">{{auto.nbplace}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!--==== Listes garanties MOBILE ===-->
                    <v-flex justify-content-center ml-3 row v-show="this.$store.state.devispayement.devis.brancheid.branche=='Automobile'" class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                <v-toolbar-title class="policeLato">Garantie(s) souscrite(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey">
                                <ul class="to-left uppercase policeLato" v-for="(gar, index) in listegaranties" :key="index">
                                    <ul v-for="(g, index) in gar" :key="index">
                                        <li>{{g}}</li>
                                    </ul>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!--==== others informations for the current DEVIS MOBILE===-->
                    <v-flex justify-content-center ml-3 row class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Autres informations</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey;">
                                <ul class="to-left policeLato" style="margin-left:-7%">
                                    <li class="font-weight-regular subheading">Date d'effet :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date d'échéance :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Assureur:
                                        <span class="to-right-mobile">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date de souscription :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Bénéficiaire :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>
        <!--=======================================End Detail block if Automobile MOBILE ========================================================-->

        <!--============== Details Assurance cas Habitation MOBILE =====================-->
        <!--============== Details Assurance cas Habitation MOBILE =====================-->
        <!--============== Details Assurance cas Habitation MOBILE =====================-->
        <!--============== Details Assurance cas Habitation MOBILE =====================-->
        <v-layout column justify-content-center v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
            <v-layout column justify-content-center class="mt-3 pb-3 mb-3 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                <v-flex>
                    <span class="font-weight-black headline policeLato">Détails de l'assurance</span>
                </v-flex>

                <v-flex class="row mt-2 policeLato" justify-content-center>
                    <!--==============Details Assurance cas Habitation MOBILE=====================-->
                    <v-flex justify-content-center ml-3 row>
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Objet(s) assuré(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group>
                                <ul class="to-left policeLato" style="margin-left:-7%">
                                    <li class="font-weight-regular subheading">Type de Bien :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.typeBien}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Type toiture :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.naturecouverture}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Superficie (m2) :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.nombreetage}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Adresse du logement :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.adresselogement}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Valeur Batiment :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.valeurbatiment}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Valeur Contenu :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.valeurcontenu}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Qualité assuré :
                                        <span class="to-right-mobile" style="font-size:13px">{{Devis_pour_souscription.qualiteassure}}</span>
                                    </li>

                                    <li v-if="Devis_pour_souscription.qualiteassure=='locataire'">Monatnt Loyer :
                                        <span>{{Devis_pour_souscription.montaLoyer}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Nombre de pièces :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.nombrepiece}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!-- garanties list for the current DEVIS MOBILE-->
                    <v-flex justify-content-center ml-3 row v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'" class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                <v-toolbar-title class="policeLato">Garantie(s) souscrite(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey;">
                                <ul class="to-left uppercase policeLato" v-for="(gar, index) in listegaranties" :key="index">
                                    <li>{{gar.libele}}</li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!--==== others informations for the current DEVIS MOBILE===-->
                    <v-flex justify-content-center ml-3 row class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Autres informations</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey;">
                                <ul class="to-left policeLato" style="margin-left:-7%">
                                    <li class="font-weight-regular subheading">Date d'effet :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date d'échéance :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Assureur :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date de souscription :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Bénéficiaire :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>

        <!--============== Details Assurance cas Voyage MOBILE =====================-->
        <!--============== Details Assurance cas Voyage MOBILE =====================-->
        <!--============== Details Assurance cas Voyage MOBILE =====================-->
        <!--============== Details Assurance cas Voyage MOBILE =====================-->
        <v-layout v-show="showPaymentBLock==true" column justify-content-center v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
            <v-layout column justify-content-center class="ml-2 mt-3 pb-2 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                <v-flex>
                    <span class="font-weight-black headline policeLato">Détails de l'assurance</span>
                </v-flex>

                <v-flex class="row mt-2 policeLato" justify-content-center>
                    <!--============================================Details Assurance cas Voyage MOBILE===================================================-->
                    <v-flex justify-content-center ml-3 row>
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Objet(s) assuré(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group>
                                <ul class="to-left policeLato" style="margin-left:-7%">
                                    <li class="font-weight-regular subheading">Pays de départ :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.pays_domicile}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Pays de destination :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.destination.PAYS}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Nombre de passagers :
                                        <span class="to-right-mobile">{{Devis_pour_souscription.nbpassager}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date de départ :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateDepart)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date de retour :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateArrivee)}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!-- garanties list for the current DEVIS MOBILE-->
                    <v-flex justify-content-center ml-3 row v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'" class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                <v-toolbar-title class="policeLato">Garantie(s) souscrite(s)</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group style="color: grey;">
                                <ul class="to-left uppercase policeLato" v-for="(gar, index) in listegaranties" :key="index">
                                    <li>{{gar}}</li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <!--==== others informations for the current DEVIS MOBILE===-->
                    <v-flex justify-content-center ml-3 row class="pt-2">
                        <v-card width="330">
                            <v-toolbar card color="rgb(91, 148, 188)" dark>
                                <v-toolbar-title class="policeLato">Autres informations</v-toolbar-title>
                            </v-toolbar>

                            <v-item-group>
                                <ul class="to-left policeLato" style="margin-left:-7%">
                                    <li class="font-weight-regular subheading">Date d'effet :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date d'échéance :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Assureur:
                                        <span class="to-right-mobile">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                    </li>

                                    <li class="font-weight-regular subheading">Date de souscription :
                                        <span class="to-right-mobile">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                    </li>
                                </ul>
                            </v-item-group>
                        </v-card>
                    </v-flex>

                    <v-flex justify-content-center ml-3 row class="pt-2">
                        <table class="table table-simple text-center">
                            <thead class="bg-light policeLato">
                                <tr>
                                    <th class="head">Prénom</th>
                                    <th class="head">Nom</th>
                                </tr>
                            </thead>

                            <tbody v-for="(item, index) in tableau_info_passager" :key="index">
                                <tr style="background:#fff">
                                    <td class="font-weight-regular subheading border">{{item.prenom_passager}}</td>
                                    <td class="font-weight-regular subheading border">{{item.nom_passager}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-layout>

        <!-- pop pour remplissage informations passagers Mobile-->
        <v-dialog v-model="dialogInfoPassager" persistent>
            <v-card v-if="isMobile()" class="border-radius policeLato scroll">
                <v-toolbar card color="#ffa409">
                    <span class="font-weight-black title policeLato" style="color:#fff">
                        <v-icon color="#fff">&#xe92d;</v-icon>
                        <span style="font-weight:bold;font-size:14px!important;">Informations passager(s)</span>
                    </span>
                </v-toolbar>

                <v-flex class="border-radius grey lighten-3 row ml-3 mr-3 mt-3 mb-3">
                    <small style="color:red" class="ml-3 mt-2">
                        * Date de naissance du passager fixée selon le devis
                    </small>
                    <v-flex xs12 ml-3 mr-3>
                        <v-form>
                            <v-container class="policeLato">
                                <v-layout column pl-2 pr-2>
                                    <v-flex xs12 md4 mb-4>
                                        <v-radio-group class="justify-content-center row" v-model="genre" row>
                                            <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                            <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                        </v-radio-group>
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-text-field v-model="prenom_passager" prepend-inner-icon="person" label="Prénom*" required hint="Votre prénom complet"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-text-field v-model="nom_passager" prepend-inner-icon="person" label="Nom*" required hint="Votre nom complet"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-text-field @keypress="onlyNumber" v-model="num_passager" prepend-inner-icon="phone" label="Numéro de téléphone*" required hint="Votre numéro de téléphone"></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout column pl-2 pr-2>
                                    <v-flex xs12 md4 class="to-top mb-4">
                                        <label for>Nationalite*</label>
                                        <select v-model="nationalite_passager" class="border col-md-11 selectatMobile pt-2">
                                            <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                                {{itm.PAYS}}
                                            </option>
                                        </select>
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-text-field slot="activator" outline label="Date de naissance*" v-model="dateNaissance" prepend-inner-icon="event" readonly></v-text-field>

                                        <!--<v-menu lazy :close-on-content-click="false" v-model="datePickerDateNais" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" label="Date de naissance*" v-model="dateNaissance" prepend-inner-icon="event"></v-text-field>
                                            <v-date-picker color="#ffa409" v-model="dateNaissance" class="mt-3" :max="new Date().toISOString().substr(0, 10)" @input="datePickerDateNais=false" locale="fr-fr"></v-date-picker>
                                        </v-menu>-->
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-text-field v-model="numero_ci_passager" prepend-inner-icon="person" label="№ Passeport*" required hint="Numéro Passport"></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout column pl-2 pr-2>
                                    <v-flex xs12 md4 class="to-top">
                                        <v-menu lazy :close-on-content-click="false" v-model="menuDelivrance" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" label="Date de délivrance*" v-model="date_delivrance" prepend-inner-icon="event"></v-text-field>
                                            <v-date-picker color="#ffa409" v-model="date_delivrance" class="mt-3" @input="menuDelivrance=false" min="1950-01-01" :max="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 md4 class="to-top">
                                        <v-menu lazy :close-on-content-click="false" v-model="menuExpiration" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" label="Date expiration*" v-model="date_expiration" prepend-inner-icon="event"></v-text-field>
                                            <v-date-picker color="#ffa409" v-model="date_expiration" class="mt-3" @input="menuExpiration=false" :min="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-flex>
                </v-flex>

                <v-flex class="justify-content-center row ml-2 mr-2">
                    <v-btn class="font-weight-bold text-white policeLato justify-content-center row" round color="red" to="/">Annuler
                    </v-btn>
                    <v-btn class="font-weight-bold text-white policeLato justify-content-center row" round color="#ffa409" @click="Detail_info_passager">Ajouter
                    </v-btn>
                </v-flex>

                <v-flex class="row text-center ml-3 mr-3">
                    <table class="table table-simple text-center">
                        <thead class="bg-light policeLato">
                            <tr>
                                <th>Prénom</th>
                                <th>Nom</th>
                            </tr>
                        </thead>

                        <tbody v-for="item in tableau_info_passager" :key="item.prenom_passager">
                            <tr style="background:#fff">
                                <td class="border">{{item.prenom_passager}}</td>
                                <td class="border">{{item.nom_passager}}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-flex>

                <v-flex class="justify-content-center ml-1 row" v-show="continue_btn">
                    <v-btn class="font-weight-bold policeLato text-white" round color="#ffa409" @click="ManipPaiement()">Continuer
                    </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>

        <v-flex justify-content-center row class="ml-1 mr-2 grey lighten-3 border border-radius">
            <!-- How to deliver The insurance if subcripted MOBILE-->
            <v-flex>
                <span class="font-weight-black headline policeLato">Checkout</span>
            </v-flex>

            <v-card width="auto" class="ml-3 mr-3 border-radius">
                <v-toolbar card color="#ffa409" dark>
                    <v-toolbar-title class="policeLato">Mode de livraison</v-toolbar-title>
                </v-toolbar>

                <v-item-group style="margin-top:-12px">
                    <ul>
                        <v-radio-group full-width v-model="mode_livraison" class="answer policeLato">
                            <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true" value="a_docimicile"></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire" disabled></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                            <h6 class="ml-5" @click="aStorMap=true">Voir plan ici</h6>
                        </v-radio-group>
                    </ul>
                </v-item-group>
            </v-card>

            <v-card width="auto" class="ml-3 mr-3 mt-2 border-radius">
                <v-toolbar card color="#ffa409" dark>
                    <v-toolbar-title class="policeLato">Mode de paiement</v-toolbar-title>
                </v-toolbar>

                <v-item-group style="margin-top:-12px">
                    <ul>
                        <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement" class="answer policeLato">
                            <v-radio color="#ffa409" class="highlight" label="Orange Money" value="mobile_money"></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Free Money" value="free_money"></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                            <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch" disabled></v-radio> 
                            <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire" disabled></v-radio>
                        </v-radio-group>
                    </ul>
                </v-item-group>
            </v-card>

            <v-flex xs8 justify-content-center column class="bg-transparent" v-show="mode_livraison">
                <span class="h6">Prime TTC: <span class="font-weight-bold" style="color: #ffa409">{{ Devis_pour_souscription.prime_ttc.toLocaleString() }}</span><small> FCFA</small></span><br>
                <span class="h6">Frais livraison: <span class="font-weight-bold" style="color: #ffa409">{{ fraisLiv }}</span><small> FCFA</small></span><br>
                <span class="h6">Frais paiement: <span class="font-weight-bold" style="color: #ffa409">{{ fraisPaiement }}</span><small> FCFA</small></span>
            </v-flex>

            <v-flex class="bg-transparent" v-show="mode_livraison">
                <span class="font-weight-black h2">TOTAL :<span class="red--text">{{mention_ttc.toLocaleString()}}</span>
                    <small> FCFA</small>
                </span>
            </v-flex>
            <!-- =========End Detail block if Habitation==========================-->

            <!-- How to paye The insurance if subcripted -->
            <div class="row block-content elevation-0 row-container bg-transparent">
                <v-flex xs8 class="offset-2 pr-5">

                    <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start" class="col-sm-3 policeLato border-radius" style="height:40px">
                        Payer
                    </v-btn>

                    <!--Bouton de Paiement par Freemoney -->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'free_money'" @click="payment_free" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>

                    <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'" @click="payment_Orabank" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>

                    <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>

                    <v-btn dark color="#ffa409" v-show="mode_payement == 'intouch'" @click="payement_intouch_start" class="col-sm-3 policeLato border-radius" style="height:40px">Payer
                    </v-btn>
                </v-flex>
            </div>
        </v-flex>

        <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="isMobile()">
            <v-card>
                <v-toolbar card color="#ffa409">
                    <span class="font-weight-black title" style="color:#fff">
                        <v-icon color="#fff">&#xe55b;</v-icon>
                        <span style="font-weight:bold;font-size:14px!important;">Plan d'accès</span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="aStorMap=false" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-layout xs10 pa-3 justify-content-center row>
                        <v-flex>
                            <iframe class="border-radius" width="100%" height="700" id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1808.921643560724!2d-17.463326864934903!3d14.710734999189677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQyJzM4LjciTiAxN8KwMjcnNDUuOCJX!5e1!3m2!1sfr!2ssn!4v1587561379330!5m2!1sfr!2ssn" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE TABLETTE   ================= -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <v-layout row wrap justify-content-center pl-2 pr-2 v-if="isTablette()">
        <v-layout row wrap justify-content-center>
            <v-flex xs11 sm10 md11 lg11 pb-3 pt-4>
                <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                    <v-toolbar-title class="text-center ml-5 pl-5">
                        <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%" />
                        <span style="font-size: 25px" class="georgia">
                            Numéro Devis : {{Devis_pour_souscription.numeroDevis}}
                        </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <p class="font-weight-bold georgia" style="color:red">
                    Vous serez redirigé vers la page d’accueil dans : {{Mano}} mn
                </p>
            </v-flex>
        </v-layout>

        <v-flex pb-3 justify-content-center class="row block-content elevation-0 row-container mt-3 grey lighten-3">
            <!--logo Assureur et Notation étoilée-->
            <v-flex pt-5 md4>
                <img :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)" :title="Devis_pour_souscription.partenaireid.societe" width="150" height="120" />
                <p class="font-weight-black pl-2">{{Devis_pour_souscription.partenaireid.societe}}</p>
            </v-flex>

            <!--Tarifs-->
            <v-flex pt-5 md3>
                <ul class="List-cout pl-1">
                    <li>
                        <p class="font-weight-bold text-center" style="color:#ffa409;font-size:25px;">
                            {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                            <small>FCFA</small>
                        </p>
                    </li>
                    <span class="font-weight-black title georgia">Prime totale</span>
                    <p>
                        <small class="title font-weight-light georgia">(Frais de dossier inclus)</small>
                    </p>
                </ul>
            </v-flex>

            <!--bouttons ...-->
            <v-flex>
                <ul class="list-boutons">
                    <li>
                        <v-btn small color="default" @click="assistanceDialogManip(Devis_pour_souscription)" class="col-md-10">
                            <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe0cf;</i>Être Rappelé
                        </v-btn>
                    </li>

                    <li>
                        <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)" class="col-md-10">
                            <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                        </v-btn>
                    </li>

                    <li>
                        <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)" class="col-md-10">
                            <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe2c4;</i> Télécharger
                        </v-btn>
                    </li>

                    <li>
                        <v-btn small color="default" @click="payement_start" class="col-md-10">
                            <i class="material-icons icon-action-devis mr-4" aria-hidden="true" data-nosnippet style="margin-left:-33%">&#xe8a1;</i>
                            Payer
                        </v-btn>
                    </li>
                </ul>
            </v-flex>
        </v-flex>

        <!--=============== Details Assurance cas Automobile WEB =====================-->
        <!-- ============== Details Assurance cas Automobile WEB =====================-->
        <!-- ============== Details Assurance cas Automobile WEB =====================-->
        <!-- ============== Details Assurance cas Automobile WEB =====================-->
        <v-flex justify-content-center row v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
            <v-flex justify-content-center class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3">
                <p class="font-weight-black headline georgia">Détails de l'assurance</p>
                <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                    <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                        <thead class="bg-light georgia">
                            <tr>
                                <th class="head">Objet(s) assuré(s)</th>
                                <th class="head">Garantie(s) souscrite(s)</th>
                                <th class="head">Autres Informations</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <!--============================================Details Assurance cas Automobile WEB===================================================-->
                                <td>
                                    <ul class="to-left mb-3 georgia" style="margin-left:-10%" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                                        <li class="font-weight-regular subheading" style="font-size:10px">
                                            Marque :
                                            <span class="to-right-tablet">{{auto.marque}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            modèle :
                                            <span class="to-right-tablet">{{auto.model}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Immatriculation :
                                            <span class="to-right-tablet">{{auto.immatriculation}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">
                                            Categorie :
                                            <span>{{auto.categorie}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">
                                            Option Utilitaire :
                                            <span>{{auto.optionUtilitaire}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading" v-show="auto.categorie=='utilitaire'">
                                            Tonnage :
                                            <span>{{auto.tonnage}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading" v-show="auto.categorie=='2_roues'">
                                            Volumetrie 2 roues :
                                            <span>{{auto.volumetrie2_roues}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Valeur à neuf :
                                            <span class="to-right-tablet">{{auto.valeur}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Valeur vénale :
                                            <span class="to-right-tablet">{{auto.valeur_venale}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Age du véhicule :
                                            <span class="to-right-tablet">{{auto.age}} an(s)</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Nombre de place(s) :
                                            <span class="to-right-tablet">{{auto.nbplace}}</span>
                                        </li>
                                        <v-divider></v-divider>
                                    </ul>
                                </td>

                                <!--============================================Liste Garanties si c'est devis Auto===================================================-->
                                <td v-show="this.$store.state.devispayement.devis.brancheid.branche=='Automobile'">
                                    <ul class="to-left uppercase georgia" v-for="(gar, index) in listegaranties" :key="index" style="margin-bottom: 200px">
                                        <ul v-for="(g, index) in gar" :key="index">
                                            <li>{{g}}</li>
                                        </ul>
                                    </ul>
                                </td>

                                <!--============================================Autres informations===================================================-->
                                <td v-if="this.$store.state.devispayement.devis.brancheid.branche=='Automobile'">
                                    <ul class="to-left pb-3" style="margin-left:-10%" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                                        <li class="font-weight-regular subheading">
                                            Date d'effet :
                                            <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Date d'échéance :
                                            <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Assureur:
                                            <span class="to-right-tablet">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading">
                                            Date de souscription :
                                            <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                        </li>

                                        <v-divider></v-divider>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </v-flex>
            </v-flex>

            <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent">
                <!-- How to deliver The insurance if subcripted WEB-->
                <v-card width="500">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true" value="a_docimicile"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire" disabled></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-card width="500" class="mt-2">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de paiement</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_payement" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="Orange money" value="mobile_money"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Free Money" value="free_money" disabled></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire" disabled></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch"></v-radio>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center v-show="mode_livraison">
                    <span class="font-weight-black h2">
                        TTC : <span class="red--text">{{ mention_ttc.toLocaleString() }}</span>
                        <small>FCFA</small>
                    </span>
                </v-flex>

                <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer
                    </v-btn>
                    <!-- boutton  qui appelle la fonction de inTouch -->
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'" @click="payment_Orabank" class="col-sm-3 georgia border-radius" style="height:40px">Payer
                    </v-btn>
                    <!-- boutton qui appelle la fonction de orangemoneydirect -->

                    <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer
                    </v-btn>
                  
                    <v-btn dark color="#ffa409" v-show="mode_payement == 'intouch'" @click="payement_intouch_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-flex>

        <!-- ============== Details Assurance cas Habitation WEB ======================-->
        <!-- ============== Details Assurance cas Habitation WEB ======================-->
        <!-- ============== Details Assurance cas Habitation WEB ======================-->
        <!-- ============== Details Assurance cas Habitation WEB ======================-->
        <v-flex justify-content-center class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3" v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
            <p class="font-weight-black headline georgia">Détails de l'assurance</p>
            <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                    <thead class="bg-light georgia">
                        <tr>
                            <th class="head">Objet(s) assuré(s)</th>
                            <th class="head">Garantie(s) souscrite(s)</th>
                            <th class="head">Autres Informations</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <!--============================================Details Assurance cas Habitation WEB===================================================-->
                            <td>
                                <ul class="to-left georgia" style="margin-left:-10%">
                                    <li class="font-weight-regular subheading">
                                        Type de Bien :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.typeBien}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Type toiture :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.naturecouverture}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Superficie (m2) :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.nombreetage}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Adresse du logement :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.adresselogement}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Valeur du bâtiment :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.valeurbatiment}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Valeur du contenu :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.valeurcontenu}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Qualité assuré :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.qualiteassure}}</span>
                                    </li>
                                    <li v-if="Devis_pour_souscription.qualiteassure=='locataire'">
                                        > Monatnt Loyer :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.montaLoyer}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Nombre de pièce(s) :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.nombrepiece}}</span>
                                    </li>
                                </ul>
                            </td>

                            <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                            <td v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'">
                                <ul class="to-left uppercase georgia" v-for="(gar, index) in listegaranties" :key="index">
                                    <ul>
                                        <li style="margin-top:-10px!important;">{{gar.libele}}</li>
                                    </ul>
                                </ul>
                            </td>

                            <!--============================================Autres informations===================================================-->
                            <td>
                                <ul class="to-left pb-3" style="margin-left:-10%">
                                    <li class="font-weight-regular subheading">
                                        Date d'effet :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Date d'échéance :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Assureur:
                                        <span class="to-right-tablet">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Date de souscription :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                    </li>

                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-flex>

            <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent">
                <!-- How to deliver The insurance if subcripted WEB-->
                <v-card width="500">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true" value="a_docimicile"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-card width="500" class="mt-2 mb-5 pb-5" style="margin-bottom:15%!important">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de paiement</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_payement" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="Orange money" value="mobile_money"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire"></v-radio>

                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center v-show="mode_livraison">
                    <span class="font-weight-black h2">
                        TTC :
                        <span class="red--text">{{ mention_ttc.toLocaleString() }}</span>
                        <small>FCFA</small>
                    </span>
                </v-flex>
            </v-flex>
        </v-flex>

        <!--============== Details Assurance cas Voyage WEB ==========================-->
        <v-flex justify-content-center class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3" v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
            <p class="font-weight-black headline georgia">Détails de l'assurance</p>

            <!--<v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container bg-transparent ">
                </v-flex>-->
            <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                    <thead class="bg-light georgia">
                        <tr>
                            <th class="head">Détails sur le bien</th>
                            <th class="head">Garantie(s) souscrite(s)</th>
                            <th class="head">Autres Informations</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <!--============================================Details Assurance cas Voyage WEB===================================================-->
                            <td>
                                <ul class="to-left georgia" style="margin-left:-10%">
                                    <li class="font-weight-regular subheading">
                                        Pays de départ :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.pays_domicile}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Pays de destination :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.destination.PAYS}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Nombre de passagers :
                                        <span class="to-right-tablet">{{Devis_pour_souscription.nbpassager}}</span>
                                    </li>
                                </ul>
                            </td>

                            <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                            <td v-show="this.$store.state.devispayement.devis.brancheid.branche!='Automobile'">
                                <ul class="to-left uppercase georgia" v-for="gar in listegaranties" :key="gar">
                                    <ul>
                                        <li>{{gar}}</li>
                                    </ul>
                                </ul>
                            </td>

                            <!--============================================Autres informations===================================================-->
                            <td>
                                <ul class="to-left pb-3" style="margin-left:-10%">
                                    <li class="font-weight-regular subheading">
                                        Date d'effet :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Date d'échéance :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Assureur:
                                        <span class="to-right-tablet">{{Devis_pour_souscription.partenaireid.societe}}</span>
                                    </li>
                                    <li class="font-weight-regular subheading">
                                        Date de souscription :
                                        <span class="to-right-tablet">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                    </li>
                                    <v-divider></v-divider>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-flex>

            <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent">
                <!-- How to deliver The insurance if subcripted WEB-->
                <v-card width="500">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true" value="a_docimicile"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-card width="500" class="mt-2">
                    <v-toolbar card color="#ffa409" dark>
                        <v-toolbar-title class="georgia">Mode de paiement</v-toolbar-title>
                    </v-toolbar>
                    <v-item-group>
                        <ul>
                            <v-radio-group full-width v-model="mode_payement" class="answer georgia">
                                <v-radio color="#ffa409" class="highlight" label="Orange money" value="mobile_money"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                                <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire"></v-radio>

                            </v-radio-group>
                        </ul>
                    </v-item-group>
                </v-card>

                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center v-show="mode_livraison">
                    <span class="font-weight-black h2">
                        TTC :
                        <span class="red--text">{{ mention_ttc.toLocaleString() }}</span>
                        <small>FCFA</small>
                    </span>
                </v-flex>
            </v-flex>
        </v-flex>

        <!-- pop pour remplissage informations passagers TABLETTE-->
        <!-- pop pour remplissage informations passagers TABLETTE-->
        <v-dialog v-model="dialogInfoPassager" persistent v-if="isTablette()">
            <v-card class>
                <v-toolbar card>
                    <span class="font-weight-black title georgia" style="color:#ffa409">
                        <v-icon color="#ffa409">&#xe92d;</v-icon>Informations passager(s)
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogInfoPassager = false" class="float-lg-right" style="color:#ffa409">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-flex class="column text-center mt-3">
                    <v-flex>
                        <v-card class="georgia" elevation="22">
                            <v-form class="text-center row">
                                <v-container class="text-center row">
                                    <v-layout p-1 pt-3 class="justify-center row">
                                        <v-flex xs6 md4>
                                            <v-text-field solo height="10" v-model="prenom_passager" placeholder="Prénom*" required hint="Votre prénom complet"></v-text-field>
                                        </v-flex>

                                        <v-flex xs6 md4>
                                            <v-text-field solo height="10" v-model="nom_passager" placeholder="Nom*" required hint="Votre nom complet"></v-text-field>
                                        </v-flex>

                                        <v-flex xs6 md4>
                                            <v-text-field @keypress="onlyNumber" solo height="10" v-model="num_passager" placeholder="Numéro de téléphone*" required hint="Votre numéro de téléphone"></v-text-field>
                                        </v-flex>

                                        <v-flex xs6 md4 style="margin-top:-15px">
                                            <label for>Nationalité*</label>
                                            <select solo v-model="nationalite_passager" class="border selectatDesktop col-md-11 pt-3">
                                                <option v-for="(itm, index) in countries" :key="index" :value="itm.PAYS">{{itm.PAYS}}
                                                </option>
                                            </select>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout p-1 pt-3 class="justify-center row">
                                        <v-flex xs12 md4>
                                            <v-menu lazy :close-on-content-click="false" v-model="datePickerDateNais" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de naissance*" v-model="dateNaissance" prepend-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="dateNaissance" class="mt-3" :max="new Date().toISOString().substr(0, 10)" @input="datePickerDateNais=false" :min="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 md4>
                                            <v-text-field solo height="10" v-model="numero_ci_passager" placeholder="CNI ou Passeport*" required type="text" hint="Numéro CNI ou numéro Passeport"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4 style="margin-top:-20px">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuDelivrance" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de délivrance*" v-model="date_delivrance" prepend-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_delivrance" class="mt-3" @input="menuDelivrance=false" min="1950-01-01" :max="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 md4 style="margin-top:-20px">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuExpiration" transition="scale-transition" offset-y full-width :nudge-right="20" max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" abel="Date d'expiration*" v-model="date_expiration" prepend-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_expiration" class="mt-3" @input="menuExpiration=false" :min="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card>

                        <v-flex class="row">
                            <div class="col-sm-12 text-center">
                                <v-btn class="text-white" round color="#ffa409" @click="Detail_info_passager">Ajouter
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-flex>
                </v-flex>

                <v-layout wrap>
                    <v-flex xs12 ml-5 mr-5>
                        <table class="table table-simple text-center">
                            <thead class="bg-light">
                                <tr>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                    <th>Numéro de téléphone</th>
                                    <th>Nationalité</th>
                                    <th>CNI ou Passeport</th>
                                    <th>Date de délivrance</th>
                                    <th>Date d'expiration</th>
                                </tr>
                            </thead>
                            <tbody v-for="(item, index) in tableau_info_passager" :key="index">
                                <tr>
                                    <td class="border">{{item.prenom_passager}}</td>
                                    <td class="border">{{item.nom_passager}}</td>
                                    <td class="border">{{item.num_passager}}</td>
                                    <td class="border">{{item.nationalite_passager}}</td>
                                    <td class="border">{{item.numero_ci_passager}}</td>
                                    <td class="border">{{item.date_delivrance}}</td>
                                    <td class="border">{{item.date_expiration}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>

                    <v-flex class="justify-content-center row">
                        <v-btn class="text-white" round color="#ffa409" @click="PayementSpecialVoyage" v-show="continue_btn">Continuer
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
    </v-layout>

    <!-- pop pour remplissage informations passagers Mobile-->
    <v-dialog v-model="dialogAlert" persistent>
        <v-card>
            <v-toolbar>
                <v-toolbar-title>
                    <span class="headline">ALERT PAIMENT NON FINALISE</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogAlert = false" class="float-lg-right" style="background: #ffa409">
                    <v-icon>&#xe5cd;</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                            <v-text-field v-model="nom_passager" label="Nom *" hint="Nom" required></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn round outline color="success" flat>Ajouter</v-btn>
                        <v-btn round outline color="blue darken-1" flat @click="dialogAlert = false">Annuler</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- popup pour demande d'assistance -->
    <v-dialog v-model="assistanceDialog" max-width="800">
        <v-card class="border-radius georgia" tile>
            <v-toolbar card dark style="background: #ffa409">
                <v-toolbar-title class="georgia">Assistance</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark flat @click="assistanceDialog= false" class="float-lg-right">
                    <v-icon>&#xe5cd;</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-container class="scroll">
                    <v-layout wrap>
                        <div id="app" class="col-md-12">
                            <v-flex xs12 sm12 md12 class="text-lg-center">
                                <label for class="greyLabel">Horaire de rappel (*)</label>
                                <select v-model="horaire" class="border col-md-11 selectatDesktop pt-2">
                                    <option v-for="(itm, index) in itema" :key="index" :value="itm">{{itm}}</option>
                                </select>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="text-lg-center">
                                <label for class="greyLabel">Canal de rappel (*)</label>
                                <select v-model="canal" class="border col-md-11 selectatDesktop pt-2">
                                    <option v-for="(itm, index) in rappel" :key="index" :value="itm">{{itm}}
                                    </option>
                                </select>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="ml-4 mr-4 text-lg-center">
                                <v-text-field label="Nom" prepend-inner-icon="portrait" v-model="name" :counter="20" required></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="ml-4 mr-4 text-lg-center">
                                <v-text-field label="Téléphone" prepend-inner-icon="call" v-model="tel" prefix="(+221)" type="number" value="0" :counter="9" required></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="ml-4 mr-4 text-lg-center">
                                <v-text-field label="Objet" prepend-inner-icon="link" disabled v-model="objetRappel" required></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="ml-4 mr-4 text-lg-center">
                                <v-textarea name="input-7-1" v-model="remarques" box label="Remarque (s)" prepend-inner-icon="feedback" auto-grow></v-textarea>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="justify-content-center row">
                                <v-btn small round class="text-white font-weight-bold georgia" color="red" style="background-color:grey">Supprimer
                                    <v-icon style="font-size:20px;">&#xe872;</v-icon>
                                </v-btn>
                                <v-btn small round class="text-white font-weight-bold georgia" color="#ffa409" @click="AddAssistance()">Valider
                                    <v-icon style="font-size:20px;">&#xe876;</v-icon>
                                </v-btn>
                            </v-flex>
                        </div>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">Génération du fichier en cours</span>
    </div>

    <!-- Modal loader start-->
    <!-- <div class="text-xs-center">
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="orange" dark>
                <v-card-text>Génération du fichier en cours
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div> -->

    <!-- Popup FreeMoney -->
    <v-dialog v-model="freepayment" max-width="1000" v-if="isDesktop()">
        <div class="containerP scroll" style="min-width:1000px;width:auto">
            <div class="icing">
                <h3>{{this.description}}</h3>
                <ul class="order" style>
                    <li>
                        <span class="item-name" style="font-size: 12px;">1 - Renseignez votre numéro de téléphone FreeMoney et cliquez sur « CONFIRMER LE PAIEMENT ».</span>
                    </li>
                    <br />

                    <li>
                        <span class="item-name" style="font-size: 12px;">2 Avec votre téléphone portable composez le #150# et validez la transaction avec votre code secret.</span>
                    </li>
                    <br />

                    <li>
                        <span class="item-name" style="font-size: 12px;">3 - Le paiement est valide, vous recevrez un sms de confirmation.<br /></span>
                    </li>
                </ul>

                <div style="margin-top:-10px;">
                    <p>Montant à payer</p>
                </div>

                <div class="total" style="font-size: 25px;margin-top:-10px;">{{ mention_ttc.toLocaleString() }}
                    <small>XOF</small>
                </div>
            </div>

            <div class="dough">
                <div class="col">
                    <div>
                        <h2>Payez par
                            <span><img src="../assets/img/freemoney.png" alt="free-money-logo" width="25%" /></span>
                        </h2>
                    </div>
                </div>

                <div class="inputs">
                    <div class="row"></div>
                    <div class="justify-content-center row rowFree mt-3">
                        <v-flex md5 class="justify-content-center rowFree">
                            <div class="column card-group">
                                <div>
                                    <label class="label">Nom</label>
                                    <input class="text-input name-input" name="nom" :placeholder="placeholdernom" disabled />
                                </div>
                            </div>
                        </v-flex>

                        <v-flex md5 class="ml-5 justify-content-center rowFree">
                            <div class="column card-group">
                                <div>
                                    <label class="label">Prénom</label>
                                </div>
                                <div>
                                    <input class="text-input name-input" name="prenom" :placeholder="placeholderprenom" disabled />
                                </div>
                            </div>
                        </v-flex>
                    </div>

                    <div class="row" style="margin-left:30px">
                        <v-flex md11 class="justify-content-center row rowFree">
                            <div class="column name-group">
                                <label class="label" for="telephone">Numéro Téléphone *</label>
                                <input class="text-input card-input" name="phone" v-model="numTelephone" />
                            </div>
                        </v-flex>
                    </div>

                    <div class="justify-center row mt-3"></div>
                </div>

                <div class="justify-center row mt-3">
                    <rotate-loader v-show="snipperfree" :loading="loading" :color="color" :size="size"></rotate-loader>
                </div>

                <div class="justify-center rowFree mt-3">
                    <v-flex md7 class="ml-3 justify-content-center rowFree">
                        <div class="column card-group">
                            <button class="order-button" @click="Gopayment_free">Confirmer le paiement</button>
                        </div>
                    </v-flex>

                    <v-flex md4 class="ml-4 justify-content-center rowFree">
                        <button class="order-button" @click="cancelFree()">Annuler</button>
                    </v-flex>
                </div>
            </div>
        </div>
    </v-dialog>

    <v-dialog v-model="freepayment" max-width="500" v-if="isMobile()">
        <v-card class="border-radius" color="white">
            <v-container>
                <v-layout class="column">
                    <v-flex class="justify-content-center row ml-1 mt-3">
                        <h2 class="justify-content-center row" style="font-size:18px">Payez par
                            <img src="../assets/img/freemoney.png" alt width="20%" style="margin-top:-10px" />
                        </h2>
                    </v-flex>

                    <v-flex class="mr-3">
                        <ul class="font-weight-bold text-center" style="font-size:12px">
                            <li>1 - Vérifiez votre numéro de téléphone Freemoney puis cliquez« CONFIRMER LE PAIEMENT
                                ».
                            </li>
                            <li>2 - Faites le #150# sur votre téléphone pour valider le paiement avec votre code
                                secret
                            </li>
                            <li>3 - Vous recevrez un sms de confirmation du paiement</li>
                        </ul>
                    </v-flex>

                    <div class="inputs">
                        <v-layout class="ml-2 mr-3 row">
                            <v-flex md4 class="ml-4 justify-content-center row rowFreeMobile">
                                <div class="column card-group">
                                    <div>
                                        <label class="label">Nom</label>
                                        <input class="text-input name-input" name="nom" :placeholder="placeholdernom " disabled />
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout class="ml-2 mr-3 row">
                            <v-flex md3 class="ml-4 justify-content-center row rowFreeMobile">
                                <div class="column card-group">
                                    <div>
                                        <label class="label">Prénom</label>
                                        <input class="text-input name-input" name="prenom" :placeholder="placeholderprenom" disabled />
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout class="ml-2 mr-3 row">
                            <v-flex class="ml-4 justify-content-center row rowFreeMobile">
                                <div class="column name-group">
                                    <label class="label" for="telephone">Numéro Téléphone *</label>
                                    <input class="text-input card-input" name="phone" v-model="numTelephone" />
                                </div>
                            </v-flex>
                        </v-layout>

                        <div class="justify-center row mt-3">
                            <rotate-loader v-show="snipperfree" :loading="loading" :color="color" :size="size"></rotate-loader>
                        </div>
                    </div>

                    <v-layout class="justify-content-center row ml-1 mr-1 mt-1 mb-3">
                        <v-flex class="justify-content-center row">
                            <div class="card-group">
                                <button class="highlight buttonFRMobile" @click="Gopayment_free">Confirmer le
                                    paiement
                                </button>
                            </div>
                        </v-flex>

                        <v-flex class="justify-content-center row">
                            <div class="card-group ">
                                <button class="order-button" @click="cancelFree()">Annuler</button>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>

    <v-dialog v-model="adresse" persistent max-width="500" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius grey lighten-3">
            <v-toolbar color="#ffa409">
                <v-toolbar-title class="policeLato text-white">Choix livraison
                    <span style="font-size: 14px">(Dakar et Banlieue)</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                    <v-icon>&#xe5cd;</v-icon>
                </v-btn>
            </v-toolbar>

            <v-container class="grey lighten-3">
                <v-layout class="justify-content-center">
                    <p class="mr-5 mt-2 font-weight-bold policeLato">Tarif Normal</p>
                    <p class="mt-2 font-weight-bold policeLato" style="margin-left:-1%!important">Tarif Express</p>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-flex class="justify-content-center container">
                        <form class="form cf">
                            <v-flex class="justify-content-center row pt-4" style="margin-top:30px">
                                <section class="ml-2 justify-conten-center row plan cf">
                                    <v-tooltip top class="ml-4 policeLato">
                                        <template v-slot:activator="{ on }">
                                            <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="free-label" for="dakar_normal" style="padding-top:15px;white-space: pre-wrap;">Dakar
                                                <span class="font-weight-bold">1500 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison le jour<br />même si contrat jusque<br />midi sinon lendemain</strong>
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <input :disabled="disable" type="radio" name="radio1" id="dakar_express" value="dakar_express" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="basic-label col" for="dakar_express" style="padding-top:15px;white-space: pre-wrap;">Dakar
                                                <span class="font-weight-bold">2000 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison dans les 2 heures<br /> Service de 8h a 17h</strong>
                                        </span>
                                    </v-tooltip>
                                </section>
                            </v-flex>

                            <v-flex class="justify-content-center row pt-4" style="margin-top:-20px">
                                <section class="ml-2 justify-conten-center row row plan cf">
                                    <v-tooltip bottom class="ml-4">
                                        <template v-slot:activator="{ on }">
                                            <input type="radio" name="radio1" id="banlieue_normal" value="banlieue_normal" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="premium-label col" for="banlieue_normal" style="padding-top:10px;white-space: pre-wrap;">Banlieue
                                                <span class="font-weight-bold">2000 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <input :disabled="disable" type="radio" name="radio1" id="banlieue_express" value="banlieue_express" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="optimium-label col" for="banlieue_express" style="padding-top:10px;white-space: pre-wrap;">Banlieue
                                                <span class="span font-weight-bold">2500 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison dans les 3 heures<br /> Service de 8h a 17h</strong>
                                        </span>
                                    </v-tooltip>
                                </section>
                            </v-flex>
                        </form>
                    </v-flex>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-flex class="ml-5 mr-5">
                        <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier" label="Veuillez selectionner votre quartier" editable item-text="quartier" item-value="quartier" color="#59595b"></v-overflow-btn>
                    </v-flex>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-flex>
                        <v-text-field class="ml-5 mr-5" prepend-inner-icon="map" label="Renseigner adresse de livraison " v-model="adresselivraison"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-btn round class="font-weight-bold text-white policeLato" style="background:red" flat @click="cancelPaiement()">Annuler
                    </v-btn>
                    <v-btn round class="font-weight-bold text-white policeLato" style="background:#ffa409" flat @click="getAdressLivraison">Valider
                    </v-btn>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>

    <v-dialog v-model="adresse" persistent max-width="auto" v-if="isMobile()">
        <v-card elevation="24" class="border-radius grey lighten-3">
            <v-toolbar color="#ffa409">
                <v-toolbar-title class="policeLato text-white">Livraison
                    <span style="font-size: 14px">(Dakar et Banlieue)</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                    <v-icon>&#xe5cd;</v-icon>
                </v-btn>
            </v-toolbar>

            <v-container class="justify-content-center">
                <v-layout class="justify-content-center row">
                    <v-flex class="justify-content-center row pt-2">
                        <section class="justify-conten-center row plan cf">
                            <p class="font-weight-bold policeLato mr-5">Tarif Normal</p>
                            <p class="font-weight-bold policeLato" style="margin-left:-6%">Tarif Express</p>
                        </section>
                    </v-flex>
                </v-layout>

                <v-layout wrap class="justify-content-center row ml-2 pt-3" style="margin-top:30px">
                    <div class="justify-content-center container">
                        <form class="form cf">
                            <v-flex class="justify-content-center row pt-2">
                                <section class="justify-conten-center row plan cf policeLato">
                                    <v-tooltip top class="ml-2">
                                        <template v-slot:activator="{ on }">
                                            <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="free-label" for="dakar_normal" style="padding-top:25px;white-space: pre-wrap">Dakar
                                                <span class="font-weight-bold">1500 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison le jour<br />même si contrat jusque<br />midi sinon lendemain</strong>
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <input :disabled="disable" type="radio" name="radio1" id="dakar_express" value="dakar_express" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="basic-label col" for="dakar_express" style="padding-top:25px;white-space: pre-wrap;">Dakar
                                                <span class="font-weight-bold">2000 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison dans les 2 heures<br /> Service de 8h a 17h</strong>
                                        </span>
                                    </v-tooltip>
                                </section>
                            </v-flex>

                            <v-flex class="justify-content-center row">
                                <section class="justify-content-center row row plan cf">
                                    <v-tooltip bottom class="ml-2">
                                        <template v-slot:activator="{ on }">
                                            <input type="radio" name="radio1" id="banlieue_normal" value="banlieue_normal" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="premium-label col" for="banlieue_normal" style="padding-top:25px;white-space: pre-wrap;">Banlieue
                                                <span class="font-weight-bold">2000 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                        </span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <input :disabled="disable" type="radio" name="radio1" id="banlieue_express" value="banlieue_express" v-model="prix_livraison" @change="showListCity" />
                                            <label v-on="on" class="optimium-label col" for="banlieue_express" style="padding-top:25px;white-space: pre-wrap;">Banlieue
                                                <span class="font-weight-bold">2500 FCFA</span>
                                            </label>
                                        </template>
                                        <span>
                                            <strong class="font-weight-bold">Livraison dans les 3 heures<br /> Service de 8h a 17h</strong>
                                        </span>
                                    </v-tooltip>
                                </section>
                            </v-flex>
                        </form>
                    </div>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-flex class="ml-4 mr-4">
                        <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier" label="Votre quartier" item-text="quartier" item-value="quartier" color="#59595b"></v-overflow-btn>
                    </v-flex>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-flex class="ml-4 mr-4">
                        <v-text-field label="Renseigner adresse de livraison " v-model="adresselivraison"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout class="justify-content-center">
                    <v-btn round class="font-weight-bold text-white georgia" style="background:red" flat @click="cancelPaiement()">Annuler
                    </v-btn>
                    <v-btn round class="font-weight-bold text-white georgia" style="background:#ffa409" flat @click="getAdressLivraison">Valider
                    </v-btn>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import Api from "../services/Api";
import store from "./../store/store";
import getUpay from "../services/getUpay";
import dayjs from "dayjs";
import getOrabank from "../services/orabank"
import ville from "./../common/ville";
import RotateLoader from 'vue-spinner/src/BounceLoader.vue'
import PushInDataLayer from '../services/TagManager'

export default {
    data() {
        return {
            GtmAssistanceVal:{},
            addedInTheCard:null,
            aStorMap: false,
            disable: false,
            devis_price:null,
            placeholderprenom: store.state.user.prenom,
            placeholdernom: store.state.user.nom,
            numTelephone: store.state.user.telephone_port,
            passenger_birthady_age: null,
            snipperfree: false,
            description: "Paiement de l'assurance VIE No: " + store.state.devispayement.numero_police + ". Assureur: " + store.state.devispayement.partenaireid.societe,
            //description: "Paiement de l'assurance " + store.state.devispayement.devis.brancheid.branche + " No: " + store.state.devispayement.devis.numeroDevis + ". Assureur: " + store.state.devispayement.devis.partenaireid.societe,
            dialogom: false,
            iframe: {
                src: "",
                loaded: false
            },
            // numTelephone : '' ,
            amenities: [1, 4],
            genre: null,
            headers: [{
                    text: "Marque & Modèle",
                    value: "marque"
                },
                {
                    text: "Immatriculation",
                    value: "immatriculation"
                },
                {
                    text: "Catégorie",
                    value: "catégorie"
                },
                {
                    text: "Force",
                    value: "force"
                },
                {
                    text: "Age",
                    value: "age"
                },
                {
                    text: "Valeur neuf",
                    value: "valeur"
                },
                {
                    text: "Valeur actuelle",
                    value: "valeur_actuelle"
                },
                {
                    text: "Nbr places",
                    value: "nbplace"
                },
                {
                    text: "Actions"
                }
            ],
            fraisLiv: 0,
            fraisPaiement: 0,
            Testons: false,
            itemsGenre: ["Homme", "Femme"],
            adresselivraison: "",
            autoHeight: true,
            x: null,
            dialogAlert: false,
            Devis_pour_souscription: [],
            mode_livraison: null,
            listVille: ville,
            mention_ttc: null,
            showPaymentBLock: false,
            menuDelivrance: false,
            dialogLoading: false,
            menuExpiration: false,
            mode_payement: null,
            notifDeviParMail: null,
            countries: null,
            ville: null,
            quartier: "",
            listegaranties: [],
            marque: null,
            tableau_info_passager: [],
            nbPassager: null,
            frais_livraison: null,
            branche: null,
            continue_btn: false,
            dialogInfoPassager: false,
            dialog: false,
            city: null,
            datePickerDateNais: false,
            IsPaid: false,
            contratToStore: null,
            nom_passager: null,
            num_passager: null,
            prenom_passager: null,
            nationalite_passager: null,
            numero_ci_passager: null,
            dateNaissance: null,
            date_delivrance: null,
            date_expiration: null,
            // listeVille: ville,
            adresse: false,
            freepayment: false,
            orabankpayment: false,
            // selectedVille: null,
            notif: null,
            ExitByUser: true,
            Mano: null,
            show: false,
            ToastTabSucess: { // Customized options for success toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 2000,
                fitToScreen: true,
                type: "success",
                className: "custom-success-class"
            },
            ToastTabError: { // Customized options for error toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 2000,
                fitToScreen: true,
                type: "error"
            },
            assistanceDialog: false,
            itema: ["Le plus tôt possible", "Dans la matinée", "Dans la journée"],
            rappel: ["Whatsapp", "Appel", "Email"],
            objet: [
                "Devis",
                "Souscription",
                "Contrat",
                "Paiement",
                "Conseil",
                "Sinistre",
                "Autres"
            ],
            horaire: null,
            canal: null,
            name: null,
            tel: null,
            objetRappel: null,
            remarques: null,
            timer: "",
            DeliveryCost:null,
        };
    },

    components: {
        RotateLoader
    },

    created() {
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 60000);

        // EXECUTION AUTOMATIQUE ET PERIODIQUE DES FONCTIONS POUR
        // DESACTIVER LES CHOIX EXPRESS DU POPUP LIVRAISON
        let result = this.$crontab.addJob({
            name: 'counter',
            interval: {
                hours: '17',
                day: '*'
            },
            job: this.disableExpress,
        });

        let stop = this.$crontab.addJob({
            name: 'stop',
            interval: {
                hours: '8',
                day: '*'
            },
            job: this.enableExpress,
        })
    },

    methods: {
        /**
         * On applique un pourcentage au montant TTC
         * ce pourcentage est supporte par le client et reverse au partenaires
         * upay, intouch, orabank et free
         */
        calculFraisPaiement() {
            /**
             * Orange Money 
             * Free Money
             * upay cash
             */
            if (this.mode_payement == 'mobile_money' || this.mode_payement == 'free_money' || this.mode_payement == 'reseau_partenaire') {
                let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.01) / (1 - 0.01);
                this.fraisPaiement = Math.round(FP * 100) / 100;
                this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
            }
            /**
             * OraBank
             * Intouch
             */
            else if (this.mode_payement == 'carte_bancaire' || this.mode_payement == 'intouch') {
                let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.02) / (1 - 0.02);
                this.fraisPaiement = Math.round(FP * 100) / 100;
                this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
            }
            /**
             * Upay
             *
             */
            else if (this.mode_payement == 'autre_paiement') {
                let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.0125) / (1 - 0.0125);
                this.fraisPaiement = Math.round(FP * 100) / 100;
                this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
            }
        },

        calculFraisLiv() {
            let ST = this.mention_ttc;
            let SN = Math.trunc(this.Devis_pour_souscription.prime_ttc);
            let frais = ST - SN;
            this.fraisLiv = frais
        },

        disableExpress() {
            this.disable = true
        },

        enableExpress() {
            this.disable = false
        },

        load: function () {
            this.iframe.loaded = true;
        },

        cancelPaiement() {
            this.adresse = false;
            this.mode_livraison = null;
            this.adresselivraison = ""
        },

        cancelFree() {
            this.freepayment = false,
                this.mode_livraison = null
        },

        cancelOrab() {
            this.orabankpayment = false
        },

        /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
        onlyNumber($event) {
            let NumOnly = $event.NumOnly ? $event.NumOnly : $event.which;
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
        },

        fetchEventsList() {
            this.Mano = this.Mano - 1;
            if (this.Mano == 0) {
                this.ExitByUser = false;
                this.$router.push("/");
            }
        },

        isMobile: function () {
            if (screen.width <= 760) {
                return true;
            } else {
                return false;
            }
        },

        isTablette() {
            if (screen.width > 425 && screen.width <= 768) {
                return true;
            } else {
                return false;
            }
        },

        isDesktop: function () {
            if (screen.width > 768) {
                return true;
            } else {
                return false;
            }
        },

        getImgUrl(pic) {
            if (pic) {
                return pic;
            } else {
                return require("../assets/img/assuraf_sm.png");
            }
        },

        // Get la liste des pays
        getListePays: function () {
            Api().get("pays/all")
                .then(response => {
                    this.countries = response.data;
                })
                .catch(err => {
                    err;
                });
        },

        showListCity() {
            if (this.prix_livraison == "dakar_normal" || this.prix_livraison == "dakar_express") {
                this.dakar = true;
                this.ville = this.listVille.Dakar;
                this.quartier = null;
            } else if (this.prix_livraison == "banlieue_normal" || this.prix_livraison == "banlieue_express") {
                this.dakar = true;
                this.ville = this.listVille.Banlieue;
                this.quartier = null;
            }
        },

        getAdressLivraison: function () 
        {
            let delivery_cost = 0

            if (this.prix_livraison) {
                if (this.prix_livraison == "dakar_normal") 
                {
                    this.mention_ttc = parseInt(this.svgTTC) + 1500;
                    delivery_cost = 1500
                    this.DeliveryCost = 1500
                } else if (this.prix_livraison == "dakar_express") 
                {
                    this.mention_ttc = parseInt(this.svgTTC) + 2000;
                    delivery_cost = 2000
                    this.DeliveryCost = 2000
                } else if (this.prix_livraison == "banlieue_normal") 
                {
                    this.mention_ttc = parseInt(this.svgTTC) + 2000;
                    delivery_cost = 2000
                    this.DeliveryCost = 2000
                } else if (this.prix_livraison == "banlieue_express") 
                {
                    this.mention_ttc = parseInt(this.svgTTC) + 2500;
                    delivery_cost = 2500
                    this.DeliveryCost = 2500
                }
                if (this.adresselivraison && this.quartier) {
                    localStorage.setItem("adressliv", this.adresselivraison);
                    localStorage.setItem("quartier",  this.quartier);
                    localStorage.setItem("typeLivraison",this.prix_livraison)
                    localStorage.setItem("delivery_cost",delivery_cost)
                    this.adresse = false;
                } else {
                    this.$toasted.show("Adresse de livraison obligatoire ! ", this.ToastTabError);
                }
            } else {
                this.$toasted.show("veuillez choisir un mode de livraison ! ", this.ToastTabError);
            }
            this.calculFraisLiv();
            this.calculFraisPaiement();
        },

        AddAssistance() {
            if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                
                const assist = {
                    horaire: this.horaire,
                    canal: this.canal,
                    name: this.name,
                    tel: this.tel,
                    objetRappel: this.objetRappel,
                    remarques: this.remarques,
                    userid: store.state.user._id
                };
                
                let Gtm2 = {
                    branche : this.GtmAssistanceVal.branche,
                    schedule : this.horaire,
                    insurer_name : this.GtmAssistanceVal.insurer_name,
                    step : 2,
                    price : this.devis_price,
                    channel :this.canal,
                    event : 'receive_call_step2'
                }
                
                Api()
                    .post("assistances/create", assist)
                    .then(resp => {
                        PushInDataLayer(Gtm2)                        
                        if (resp.data.info == "ok") {
                            this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                            this.assistanceDialog = false;
                            this.horaire = "";
                            this.canal = "";
                            this.name = "";
                            this.tel = "";
                            this.objetRappel = "";
                            this.remarques = "";
                        } else if (resp.data.info == "nok") {
                            this.$toasted.show(resp.data.msg, this.ToastTabError);
                        }
                        
                    });
            } else {
                this.$toasted.show(
                    "Tous les champs sont obligatoires !",
                    this.ToastTabError
                );
            }
        },

        devisParMail: function (params) {
            Api()
                .get("devis/mydevisbyemail/" + params.devisid)
                .then(response => {
                    this.notifDeviParMail = response.data.info;
                });
        },

        // chargement du popup pour les infos de payement avec UPAY
        payement_start: function () 
        {
            if (this.mode_payement) 
            {
                if (this.mode_livraison) 
                {
                    this.begin_checkoutPushin()
                    let montant = this.mention_ttc;
                    localStorage.setItem('amount', montant);
                    let numDevis = this.Devis_pour_souscription.numeroDevis;
                    localStorage.setItem('numdevis', numDevis);
                    localStorage.setItem('canal', "Upay");
                    getUpay(this.mention_ttc, this.mode_payement);
                } else {
                    this.$toasted.show(
                        "Mode livraison obligatoire !",
                        this.ToastTabError
                    );
                }
            } else {
                this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
            }
        },

        payment_free: function () {
            if (this.mode_payement) {
                if (this.mode_livraison) {
                    this.freepayment = true;
                } else {
                    this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                }
            } else {
                this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
            }
        },

        /*================ Debut de la Transaction par Free Money =======================*/
        Gopayment_free: function () 
        {
            this.snipperfree = true;    
            localStorage.setItem('numdevis', this.Devis_pour_souscription.numeroDevis);
            localStorage.setItem('amount', this.mention_ttc);
            localStorage.setItem('canal', "FreeMoney");
            this.begin_checkoutPushin()
            FreeMoney( this.mention_ttc, this.mode_payement, this.numTelephone)
             .then(resp => {
                    if (resp.data) {
                        setTimeout(() => {
                            this.freepayment = false;
                            this.$router.push("/payment/freemoneyrep")
                        }, 50000)
                    }
                })
                .catch(e=>{
                    this.$router.push("/payment/freemoneyrep")
                })
           
        },

        payment_Orabank: function () 
        {
            if (this.mode_payement) 
            {
                if (this.mode_livraison) 
                {
                    this.begin_checkoutPushin()
                    let montant = this.mention_ttc;
                    localStorage.setItem('amount', montant);
                    let numDevis = this.Devis_pour_souscription.numeroDevis;
                    localStorage.setItem('numdevis', numDevis);
                    localStorage.setItem('canal', "Orabank");
                    getOrabank(this.mention_ttc, this.mode_payement);
                } else {
                    this.$toasted.show(
                        "Mode livraison obligatoire !",
                        this.ToastTabError
                    );
                }
            } else {
                this.$toasted.show(
                    "Mode de payement obligatoire !",
                    this.ToastTabError
                );
            }
        },

        // chargement du popup pour les infos de payement avec inTouch
        payement_intouch_start: function () 
        {
                
            if (this.mode_payement) 
            {
                if (this.mode_livraison) 
                {
                    this.begin_checkoutPushin()
                    let montant = this.mention_ttc;
                    localStorage.setItem('amount', montant);
                    let numDevis = this.Devis_pour_souscription.numeroDevis;
                    localStorage.setItem('numdevis', numDevis);
                    localStorage.setItem('canal', "inTouch");
                    inTouch(this.mention_ttc, this.mode_payement);
                } else {
                    this.$toasted.show(
                        "Mode livraison obligatoire !",
                        this.ToastTabError
                    );
                }
            } else {
                this.$toasted.show(
                    "Mode de payement obligatoire !",
                    this.ToastTabError
                );
            }
        },

        payement_om_start: function () 
        {
            if (this.mode_payement)
             {
                if (this.mode_livraison) 
                {
                    this.begin_checkoutPushin()
                    let montant = this.mention_ttc;
                    localStorage.setItem('amount', montant);
                    let numDevis = this.Devis_pour_souscription.numeroDevis;
                    localStorage.setItem('numdevis', numDevis);
                    localStorage.setItem('canal', "Orange Money");
                    getOm(this.mention_ttc, this.mode_payement);

                } else {
                    this.$toasted.show(
                        "Mode livraison obligatoire !",
                        this.ToastTabError
                    );
                }
            } else {
                this.$toasted.show(
                    "Mode de payement obligatoire !",
                    this.ToastTabError
                );
            }
        },

        telecharger_le_devis: function (params) {
            this.dialogLoading = true;
            Api()
                .get("devis/download/" + params.devisid)
                .then(response => {
                    let url = response.data.lien;
                    
                    WinOpener = null
                    this.dialogLoading = false, WinOpener = window.open(),WinOpener.location = url
                })
        },

        assistanceDialogManip(devis) 
        {
            this.devis_price = devis.prime_ttc
            this.GtmAssistanceVal.branche = devis.brancheid.branche.toLowerCase()
            this.GtmAssistanceVal.insurer_name = devis.partenaireid.societe
            this.GtmAssistanceVal.step = 1
            this.GtmAssistanceVal.event = 'receive_call_step1'

            PushInDataLayer(this.GtmAssistanceVal)
            
            this.objetRappel = "Devis : " + devis.numeroDevis;
            this.name = store.state.user.prenom.toUpperCase() + "-" + store.state.user.nom.toUpperCase();
            this.tel = store.state.user.telephone_port;
            this.assistanceDialog = true;
        },

        //  Ancienne fonction pour formattage de Date (:-)
        DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format("DD-MM-YYYY");
                educatio_plus  }
        },

        //Fonction permettant de fermer le popup liste passager et declencher popup Upay
        PayementSpecialVoyage() {
            this.dialogInfoPassager = false;
            //this.dialog = true
            getUpay(this.mention_ttc, this.mode_payement);
        },

        ManipPaiement() {
            this.dialogInfoPassager = false,
                this.showPaymentBLock = true
        },

        payement_end() {
            this.begin_checkoutPushin()
            store.dispatch("setOrderId", "IDO17102019-CNM");
            store.dispatch("setmodePaiement", this.mode_payement);
            this.$router.push("/payement/succes/?amanpay=1&apsuccess=1&aporderid=900032-78c8507&aptrxid=33778037902240883")
            ;
        },

        Detail_info_passager() 
        {
            if (
                this.nom_passager &&
                this.prenom_passager &&
                this.nationalite_passager &&
                this.num_passager
            ) {
                if (
                    this.numero_ci_passager &&
                    this.date_delivrance &&
                    this.date_expiration &&
                    this.dateNaissance &&
                    this.genre
                ) {
                    let Un_passager = {
                        nom_passager: this.nom_passager,
                        prenom_passager: this.prenom_passager,
                        num_passager: this.num_passager,
                        nationalite_passager: this.nationalite_passager,
                        numero_ci_passager: this.numero_ci_passager,
                        dateNaissance: this.dateNaissance,
                        date_delivrance: this.date_delivrance,
                        date_expiration: this.date_expiration,
                        genre: this.genre
                    };

                    if (this.nbPassager > 0) {
                        this.tableau_info_passager.push(Un_passager);
                        this.nom_passager = "";
                        this.prenom_passager = "";
                        this.num_passager = "";
                        this.nationalite_passager = "";
                        this.numero_ci_passager = "";
                        this.date_delivrance = "";
                        this.date_expiration = "";
                        this.genre = "";
                    }

                    this.nbPassager = this.nbPassager - 1;
                    if (this.nbPassager === 0) {
                        this.$store.dispatch("setListeBeneficiaire", this.tableau_info_passager);
                        localStorage.setItem('BeneficiaireArray', JSON.stringify(this.tableau_info_passager))
                        this.continue_btn = true;
                    }
                } else {
                    this.$toasted.show("Tous les (*) sont obligatoires ! ", this.ToastTabError);
                }
            } else {
                this.$toasted.show("Tous les (*) sont obligatoires ! ", this.ToastTabError);
            }
        },

        add_shipping_infoPushing()
        {
            let itemPushing = {
                event: 'add_shipping_info',
                ecommerce: {
                    shipping_tier: this.mode_livraison,
                    items:this.addedInTheCard.ecommerce.items
                }
            }
            PushInDataLayer(itemPushing)
        },

        /*=============================================================*/
        /*Prepare purchase data to Push purchase event in the dataLayer*/
        /*=============================================================*/ 
        purchasePushinPreparation()
        {
            let value = this.addedInTheCard.ecommerce.items[0].price +  Math.round(this.DeliveryCost/655.957)
            this.addedInTheCard.ecommerce.items[0].item_coupon = ''
            
            let purchasePushin = 
            {
                'event': 'purchase',
                'ecommerce': {
                        'transaction_id': null,
                        'affiliation': '',
                        'value': value,
                        'tax': Math.round(this.Devis_pour_souscription.taxe/655.957),
                        'shipping': Math.round(this.DeliveryCost/655.957),
                        'currency': 'EUR',
                        'coupon': '',
                        'items': this.addedInTheCard.ecommerce.items                    
                }    
            }
            localStorage.setItem('purchasePushin', JSON.stringify(purchasePushin))
        },

        add_payment_infoPushing(Payment_Type)
        {
            let itemPushing = {
                event: 'add_payment_info',
                ecommerce: {
                    payment_type:Payment_Type,
                    items:this.addedInTheCard.ecommerce.items
                }
            }
            PushInDataLayer(itemPushing)
        },

        /*************************************************/
        /*Push begin_checkout Data and event to DataLayer*/
        /*************************************************/
        begin_checkoutPushin()
        {
                let itemPushing = {
                event: 'begin_checkout',
                ecommerce: {
                    items:this.addedInTheCard.ecommerce.items
                }
            }
            PushInDataLayer(itemPushing)
        }

    },

    beforeDestroy() 
    {
        this.purchasePushinPreparation()
        localStorage.setItem('Recurrentpayment', true)
        
        if (this.ExitByUser == true) 
        {
            clearInterval(this.timer);
        } else {
            clearInterval(this.timer);
        }
    },

    watch: {
        notifDeviParMail: function () {
            if (this.notifDeviParMail == "ok") {
                this.$toasted.show(
                    "Votre devis vous a été envoyé par mail",
                    this.ToastTabSucess
                );
            } else {
                this.$toasted.show(
                    "Le devis n'a pas pu être envoyé par mail",
                    this.ToastTabError
                );
            }
        },

        mode_payement:function(val)
        {
           let PayType = ''
            switch (val) 
            {
                case 'mobile_money': PayType = 'Orange Money';  break;
                case 'free_money':   PayType = 'Free Money';  break;
                case 'carte_bancaire':  PayType = 'Carte Bancaire';   break;
                case 'intouch':         PayType ='Intouch';   break;
                case 'autre_paiement':  PayType ='Autres paiements mobile'; break;
            }
            this.add_payment_infoPushing(PayType)
        },
       
        mode_livraison: function () {
            this.add_shipping_infoPushing()
            this.mention_ttc = parseInt(this.svgTTC);

            if (this.mode_livraison == "a_domicile") {
                this.adresse = true;
                this.prix_livraison = null;
            } else if (this.mode_livraison == "reseau_partenaire") {
                this.mention_ttc = parseInt(this.svgTTC) + 500;
                localStorage.removeItem('adressliv')
            } else if (this.mode_livraison == "locaux_assuraf") {
                this.mention_ttc = parseInt(this.svgTTC);
                localStorage.removeItem('adressliv')
            }
            this.calculFraisLiv();
            this.calculFraisPaiement();
        }
    },

    mounted: function () {
        window.scrollTo(0, 0);
        this.getListePays();
        if (this.$store.state.user && this.$store.state.devispayement !== null) 
        {
            this.mention_ttc = this.$store.state.devispayement.prime_ttc;
            this.svgTTC = this.$store.state.devispayement.prime_ttc;
            this.Devis_pour_souscription = this.$store.state.devispayement;
            this.branche = this.$store.state.devispayement.brancheid.branche;
            let view_itemPushing = {
                event: 'add_to_cart',
                ecommerce: {
                    items: [
                        {
                            'item_name': 'Assurance '+ this.branche.toLowerCase(),
                            'item_id': this.Devis_pour_souscription.numeroDevis,
                            'price': Math.ceil(this.mention_ttc/650),
                            'item_brand': this.Devis_pour_souscription.partenaireid.societe,
                            'item_category': this.branche,
                            'item_list_name': localStorage.getItem('item_list_name'),
                            'index': 1,
                            'quantity': '1'
                        }
                    ]
                }
            }
            
            this.addedInTheCard = view_itemPushing

            if(document.readyState=='complete')
            {        
                PushInDataLayer(view_itemPushing)
            }

            if (this.branche == "Voyage") 
            {
                this.dialogInfoPassager = true
                this.passenger_birthady_age = JSON.parse(localStorage.getItem('passenger-birthady-age'))
                this.dateNaissance = this.passenger_birthady_age.dateNaissance
            }

            if (this.$store.state.devispayement.brancheid.branche == "Automobile") 
            {
                for (let index = 0; index < this.Devis_pour_souscription.vehicules.length; index++) {
                    this.listegaranties.push(this.Devis_pour_souscription.vehicules[index].garanties);
                }
            } else {
                this.listegaranties = this.Devis_pour_souscription.garanties;
            }

            if (this.$store.state.devispayement.brancheid.branche == "Voyage") {
                this.nbPassager = this.$store.state.devispayement.nbpassager;
            }
       
        this.Mano = 20;
    }else{
        this.$router.push("/");
    }
}
}
</script>

<style scoped>
.row-container {
    background: white;
}

.to-top {
    margin-top: -5%;
}

.to-left {
    text-align: left;
}

.to-right {
    float: right;
}

.to-right-mobile {
    float: right;
    margin-right: 2%;
}

.to-right-tablet {
    float: right;
    font-size: 12px;
}

.to-left span {
    color: black;
    font-weight: bold;
}

.table-donnees {
    border-collapse: collapse;
}

.table-donnees tr td {
    border: 1px solid lightgrey !important;
}

.List-cout li {
    list-style: none;
}

.list-boutons li {
    list-style: none;
}

.logo-assureur {
    border: 1px solid lightgrey;
}

.right--texting {
    text-align: right;
}

.right--texting ul li .col-lg-6:hover {
    background: #ffa409;
    color: white;
    text-decoration: none;
}

.answer {
    position: relative;
    margin-right: 0;
    float: left;
    display: block;
    margin-right: 2.12766%;
    width: 100%;
}

.highlight {
    padding: 6px 12px;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    font-size: 0.0625rem;
    cursor: pointer;
    color: #6d6d6d;
    border: solid 1px transparent;
    border-bottom: solid 1px #e9e9e9;
    border-radius: 3px;
    transition: background 0.4s;
}

.highlight:hover {
    background-color: rgba(255, 164, 9, 0.3);
    padding-left: 10px;
    transition-duration: 0.5s;
}

ul li {
    list-style: none;
    padding-top: 7px;
}

.container {
    padding: 0px !important;
}

.uppercase {
    font-weight: bold;
    color: #ffa409;
    text-transform: uppercase;
    font-size: 16px;
}

.head {
    background-color: rgb(91, 148, 188);
    color: white;
    font-size: 18px;
}

.selectatMobile {
    background: url(https://) no-repeat right;
    -webkit-appearance: none;
    background-position-x: 95%;
    border-bottom: 1px solid gray;
}

.selectatDesktop {
    background: url(https://) no-repeat right;
    -webkit-appearance: none;
    background-position-x: 90%;
    border-bottom: 1px solid gray;
}

.georgia {
    font-family: Georgia !important;
}

.border-radius {
    border-radius: 20px !important;
}

.card-desktop {
    height: 150px !important;
    width: 150px !important;
}

.form .plan input,
.form .payment-plan input,
.form .payment-type input {
    display: none;
}

.form label {
    /* margin-top: 15px; */
    width: 120px;
    position: relative;
    color: #333;
    font-family: Georgia !important;
    border-radius: 20px !important;
    background-color: #fff;
    font-size: 15px;
    text-align: center;
    height: 120px;
    display: block;
    cursor: pointer;
    border: 3px solid transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.form .plan input:checked+label,
.form .payment-plan input:checked+label,
.form .payment-type input:checked+label {
    border-radius: 20px !important;
    background-color: #ffa409;
    color: #fff;
}

.form .plan input:checked+label:after,
form .payment-plan input:checked+label:after,
.form .payment-type input:checked+label:after {
    content: "\2713";
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 100%;
    border: 2px solid #ffa409;
    background-color: #fff;
    color: #ffa409;
    z-index: 999;
    position: absolute;
    top: -10px;
    right: -10px;
}

/*================== CSS SELECT GLOBAL AUTO===================*/
/* Reset Select */
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;

    background: #fff;
}

/* Remove IE arrow */
select::-ms-expand {
    display: none;
}

select {
    flex: 1;
    padding: 0 0.5em;
    color: grey;
    cursor: pointer;
}

/*================== CSS SELECT DESKTOP AUTO===================*/
/* Custom Select */
.select {
    position: relative;
    display: flex;
    width: 100%;
    height: 3em;
    line-height: 3;
    background: #fff;
    overflow: hidden;
    border: 2px solid #d3d3d3 !important;
    border-radius: 35px;
}

/* Arrow */
.select::after {
    content: "\2228";
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1em;
    background: #fff;
    cursor: pointer;
    pointer-events: none;
    -webkit-transition: 0.25s all ease;
    -o-transition: 0.25s all ease;
    transition: 0.25s all ease;
}

/* Transition */
.select:hover::after {
    color: #f39c12;
}

/*css popup Free*/

.containerP {
    margin-top: 15px;
    font-family: PT Sans, sans-serif;
    font-size: 18px;
    max-width: 500px;
    height: 500px;
    background: white;
    border-radius: 9px;
    overflow: hidden;
}

.icing,
.dough {
    float: left;
    padding: 20px;
    box-sizing: border-box;
    height: 100%;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    text-align: center;
}

.icing {
    width: 33%;
    position: relative;
    padding-right: 24px;
    background: -webkit-gradient(linear,
            left top,
            right top,
            from(#ffa409),
            color-stop(100%, #6c757d));
    background: linear-gradient(to right, #ffa409 100%, #6c757d 80%);
    color: white;
}

.icing:before {
    content: "";
    width: 36px;
    height: 36px;
    display: block;
    position: absolute;
    top: -18px;
    right: -7.2px;
    z-index: 1;
}

.dough {
    width: 67%;
    padding-left: 36px;
    color: black;
}

.order {
    -webkit-box-flex: 1;
    flex-grow: 1;
    /* padding: 20px 0;
        margin: 20px 0; */
    border: 1px solid white;
    border-color: white transparent;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
}

.order li {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    text-align: center;
}

h2 {
    font-size: 1.2em;
}

.total {
    font-size: 22px;
    text-align: center;
    font-weight: bold;
}

.inputs {
    -webkit-box-flex: 1;
    flex-grow: 1;
}

.rowFree {
    width: 100%;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: end;
    align-items: flex-end;
    margin-bottom: 6px;
}

.rowFreeMobile {
    /* width: 100%; */
    display: -webkit-box;
    display: flex;
    -webkit-box-align: end;
    align-items: flex-end;
    margin-bottom: 6px;
}

.column {
    width: 100%;
}

.column:not(:last-child) {
    margin-right: 10px;
}

.label,
.text-input {
    float: left;
    display: block;
    clear: both;
}

.label {
    font-size: 0.8em;
    margin-bottom: 0.2em;
}

.text-input {
    box-sizing: border-box;
    width: 90%;
    padding: 10px;
    font-size: 1em;
    font-family: inherit;
    background: white;
    border: 1px solid #ffa409;
    border-radius: 5px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) inset;
}

.name-group {
    -webkit-box-flex: 1;
    flex-grow: 1;
    flex-basis: 200px;
}

.order-button {
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    font-family: inherit;
    color: inherit;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(144, 81, 14, 0.3);
    box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
    border-radius: 5px;
    -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
}

.buttonFRMobile {
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    font-family: inherit;
    color: inherit;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(144, 81, 14, 0.3);
    box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
    border-radius: 5px;
    -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
}

.order-button:hover {
    background: #ffa409;
    color: white;
    border-color: transparent;
}

.policeLato {
    font-family: Lato, "Helvetica Neue", Arial, sans-serif
}


.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
